import { render, staticRenderFns } from "./Brow.vue?vue&type=template&id=215675f8&scoped=true&"
import script from "./Brow.vue?vue&type=script&lang=js&"
export * from "./Brow.vue?vue&type=script&lang=js&"
import style0 from "./Brow.vue?vue&type=style&index=0&id=215675f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215675f8",
  null
  
)

export default component.exports